import { useState } from 'react';
import type { SignatureRecordData } from '@/lib/case_signatures';
import { GenesisPanel } from './GenesisPanel';
import { PhysicalMatrixPanel } from './PhysicalMatrixPanel';
import { SegmentedInstrumentSelector, type InstrumentKey } from './SegmentedInstrumentSelector';
import { TopographyPanel } from './TopographyPanel';

export interface InstrumentPanelsProps {
  caseId: string;
  contested: SignatureRecordData;
  selectedPattern: SignatureRecordData | null;
}

/**
 * Instrumentação visual honesta da E26 (topografia de pressão estimada + // ux-neutrality:allow doc-comment
 * gênese gráfica + matriz de convergência física), agora num seletor // ux-neutrality:allow doc-comment
 * segmentado de uma linha (E29.F1/ADR-0040 §C). O estado "qual instrumento // ux-neutrality:allow doc-comment
 * está aberto" vive aqui (radio), um por vez; os painéis são controlados de // ux-neutrality:allow doc-comment
 * fora via `open` e só montam o corpo (busca on-demand) quando selecionados. // ux-neutrality:allow doc-comment
 */
export function InstrumentPanels({
  caseId,
  contested,
  selectedPattern,
}: InstrumentPanelsProps): JSX.Element {
  const [active, setActive] = useState<InstrumentKey | null>(null);
  const toggle = (key: InstrumentKey): void =>
    setActive((current) => (current === key ? null : key));

  return (
    <div className="instrument-panels">
      <SegmentedInstrumentSelector active={active} onToggle={toggle} />
      <TopographyPanel
        open={active === 'topography'}
        caseId={caseId}
        contested={contested}
        selectedPattern={selectedPattern}
      />
      <GenesisPanel
        open={active === 'genesis'}
        caseId={caseId}
        contested={contested}
        selectedPattern={selectedPattern}
      />
      <PhysicalMatrixPanel
        open={active === 'matrix'}
        caseId={caseId}
        contested={contested}
        selectedPattern={selectedPattern}
      />
    </div>
  );
}
